export const enum EExportarModeloCrf {
    MODELO_IMPORTACAO_TAP,
    MODELO_IMPORTACAO_CAPEX,
    MODELO_IMPORTACAO_RFA,
    MODELO_IMPORTACAO_ANUAL,
}